<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
		
<!-- 第一层（替换后的“专注行业解决方案”板块） -->
<!-- 替换原“第一层（替换后的‘专注行业解决方案’板块）”为以下内容 -->
<div class="row" style="position: relative; padding: 180px 0; background: #f8faff; overflow: hidden;">
  <div style="max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between;">
    <!-- 左侧文字区域 -->
    <div style="width: 50%; padding-right: 40px;">
      <!-- 标题（带蓝色边框） -->
      <div style="font-size: 28px; font-weight: bold; color: #333; line-height: 1.4; margin-bottom: 20px; padding-left: 5px;">
        打破生产“黑箱”，打造透明丶<br>
        敏捷丶自驱动的智能工厂
      </div>
      <!-- 描述文本 -->
      <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 30px;">
       部署MES等核心系统，为企业提供从订单到成品的全链条数据洞察。实时优化排产丶精准追溯质量丶提升设备效率，让制造过程全程可视、决策智能。
      </div>
      <!-- 预约演示按钮 -->
      <button style="padding: 10px 20px; background: #0e0e0e; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">
        预约演示
      </button>
      <!-- 功能标签区域 -->
      <!-- <div style="display: flex; gap: 60px; margin-top: 80px; flex-wrap: wrap;">
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">📊</span>
          综合营收
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">📡</span>
          物联网采集
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">🗺️</span>
          GIS管网巡检
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">🔍</span>
          安检&工单
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">📢</span>
          监控调度
        </div>
      </div> -->
    </div>
    <!-- 右侧图表占位区域 -->
    <div style="width: 45%; background: #fff; border-radius: 8px; padding: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
      <!-- 这里替换为实际图表（比如ECharts），先占位 -->
      <div style="width: 100%; height: 250px;  border-radius: 4px; display: flex; justify-content: center; align-items: center;">
        <img src="../../assets/img/banner2.jpg" style="width: 130%; border-radius: 8px; object-fit: cover;" />
      </div>
    </div>
  </div>
</div>

<!-- 第二层（车间管理常见问题板块） -->
<div style="margin: 80px auto; min-height: 400px; width: 1200px; padding: 40px; background: #f8faff; border-radius: 8px; box-shadow: 0 2px 12px rgba(0,0,0,0.05);">
  <!-- 标题区域 -->
  <div style="color: #000; font-size: 32px; font-weight: bold; text-align: center; margin-bottom: 10px;">
    车间管理常见问题
  </div>
  <div style="color: #666; font-size: 14px; text-align: center; margin-bottom: 40px;">
    打通全流程透明·数据驱动的精益生产提效中
  </div>

  <!-- 问题卡片区域（2行3列布局） -->
  <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px; justify-items: center;">
    <!-- 第一行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 15px; padding: 20px; text-align: center; width: 100%; max-width: 220px;">
      <div style="width: 80px; height: 80px; background: #409eff; border-radius: 16px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 28px;">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 4v16H5V4h14zM9 10h6M9 14h6M9 6h6M9 18h6"/>
        </svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">生产现场管理混乱</div>
      <div style="font-size: 14px; color: #666; line-height: 20px;">造成资源和物料的浪费</div>
    </div>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 15px; padding: 20px; text-align: center; width: 100%; max-width: 220px;">
      <div style="width: 80px; height: 80px; background: #2dd4bf; border-radius: 16px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 28px;">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"/>
          <path d="M16 2v4"/>
          <path d="M8 18v-1"/>
          <path d="M12 18v-3"/>
          <path d="M16 18v-5"/>
        </svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">生产进度不透明</div>
      <div style="font-size: 14px; color: #666; line-height: 20px;">给业务和跟单带来诸多不便</div>
    </div>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 15px; padding: 20px; text-align: center; width: 100%; max-width: 220px;">
      <div style="width: 80px; height: 80px; background: #ef4444; border-radius: 16px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 28px;">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">产品不良率不了解</div>
      <div style="font-size: 14px; color: #666; line-height: 20px;">质量控制难度大</div>
    </div>

    <!-- 第二行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 15px; padding: 20px; text-align: center; width: 100%; max-width: 220px;">
      <div style="width: 80px; height: 80px; background: #f59e0b; border-radius: 16px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 28px;">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">仓库管理不规范</div>
      <div style="font-size: 14px; color: #666; line-height: 20px;">造成材料积压过多</div>
    </div>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 15px; padding: 20px; text-align: center; width: 100%; max-width: 220px;">
      <div style="width: 80px; height: 80px; background: #8b5cf6; border-radius: 16px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 28px;">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">生产排程不合理</div>
      <div style="font-size: 14px; color: #666; line-height: 20px;">造成订单延误和爆单经常发生</div>
    </div>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 15px; padding: 20px; text-align: center; width: 100%; max-width: 220px;">
      <div style="width: 80px; height: 80px; background: #10b981; border-radius: 16px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 28px;">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">物料直捡麻烦</div>
      <div style="font-size: 14px; color: #666; line-height: 20px;">造成人力资源成本上升</div>
    </div>
  </div>
</div>

<div style="background: linear-gradient(338deg, rgb(238, 238, 255), transparent);padding-top: 20px;padding-bottom: 20px;">
  <!-- 第三层（MES企业制造执行系统板块） -->
<div style="margin: 80px auto; min-height: 400px; width: 1200px; padding: 40px; ">
  <!-- 顶部标题区域 -->
  <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 30px;">市场洞察</div>
  <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 20px;">
    
    <div style="font-size: 28px; font-weight: bold; color: #333;">
      MES企业制造执行系统
    </div>
  </div>

  <!-- 内容分栏：左文右图 -->
  <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 40px;">
    <!-- 左侧文字列表区域 -->
    <div style="width: 45%;">
      <div style="font-size: 16px; color: #333; line-height: 28px; margin-bottom: 20px;">
        <div style="margin-bottom: 15px; display: flex; gap: 10px;">
          <div style="width: 24px; height: 24px; flex-shrink: 0; display: flex; justify-content: center; align-items: center; background: #e1f5ff; color: #409eff; border-radius: 4px; font-weight: bold;">1</div>
          <div>
            <span style="font-weight: 600;">工艺过程标准化控制</span>
            <p style="color: #666; font-size: 14px; margin: 5px 0 0; line-height: 22px;">
              通过将标准工艺固化到系统，强制生产执行线。利用防错技术对物料、参数与顺序进行校验，确保工位操作一致性，从源头杜绝差错。
            </p>
          </div>
        </div>

        <div style="margin-bottom: 15px; display: flex; gap: 10px;">
          <div style="width: 24px; height: 24px; flex-shrink: 0; display: flex; justify-content: center; align-items: center; background: #e1f5ff; color: #409eff; border-radius: 4px; font-weight: bold;">2</div>
          <div>
            <span style="font-weight: 600;">实时监控生产过程</span>
            <p style="color: #666; font-size: 14px; margin: 5px 0 0; line-height: 22px;">
              通过看板与监控手段，透明化展示全局进度、质量信息和工艺参数，实时获取现场数据与异常，助力管理者快速识别问题与响应决策。
            </p>
          </div>
        </div>

        <div style="margin-bottom: 15px; display: flex; gap: 10px;">
          <div style="width: 24px; height: 24px; flex-shrink: 0; display: flex; justify-content: center; align-items: center; background: #e1f5ff; color: #409eff; border-radius: 4px; font-weight: bold;">3</div>
          <div>
            <span style="font-weight: 600;">与严格的质量管控</span>
            <p style="color: #666; font-size: 14px; margin: 5px 0 0; line-height: 22px;">
              将质量管控嵌入制造流程，系统自动触发检验任务，引导电子化记录与判定，满足质量溯源、问题定位与追溯需求，推动从缺陷到根本原因分析的闭环管理。
            </p>
          </div>
        </div>

        <div style="margin-bottom: 15px; display: flex; gap: 10px;">
          <div style="width: 24px; height: 24px; flex-shrink: 0; display: flex; justify-content: center; align-items: center; background: #e1f5ff; color: #409eff; border-radius: 4px; font-weight: bold;">4</div>
          <div>
            <span style="font-weight: 600;">构建“人机料法环”全要素数据链</span>
            <p style="color: #666; font-size: 14px; margin: 5px 0 0; line-height: 22px;">
              通过唯一产品标识，实现从原料到成品的正反向精准追溯，让生产过程“一目了然”，支持快速精准决策。
            </p>
          </div>
        </div>

        <div style="display: flex; gap: 10px;">
          <div style="width: 24px; height: 24px; flex-shrink: 0; display: flex; justify-content: center; align-items: center; background: #e1f5ff; color: #409eff; border-radius: 4px; font-weight: bold;">5</div>
          <div>
            <span style="font-weight: 600;">辅助精准生产</span>
            <p style="color: #666; font-size: 14px; margin: 5px 0 0; line-height: 22px;">
              自动采集各工序计时数量、合格产量等现场数据，作为绩效考核依据，实现公正、透明的绩效工资计算，有效激励员工。
            </p>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 45%;  ">
      <!-- 这里替换为实际图表（比如ECharts），先占位 -->
      <div style="width: 100%;  border-radius: 4px; display: flex; justify-content: center; align-items: center;">
        <img src="../../assets/img/zlindex22.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
      </div>
    </div>
    <!-- <div style="width: 40%; position: relative;">

      <div style="width: 280px; height: 280px; border: 8px solid #e1f5ff; border-radius: 50%; position: absolute; right: 0; top: 20px; z-index: 1;"></div>

      <div style="width: 240px; height: 240px; background: #fff; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); padding: 20px; position: relative; z-index: 2; margin: 40px 20px 0 0;">
  
        <div style="width: 120px; height: 120px; margin: 0 auto 20px; position: relative;">
          <div style="width: 100%; height: 100%; border-radius: 50%; background: conic-gradient(#409eff 0% 60%, #e1f5ff 60% 100%);"></div>
          <div style="width: 80px; height: 80px; background: #fff; border-radius: 50%; position: absolute; top: 20px; left: 20px; display: flex; justify-content: center; align-items: center; font-size: 14px; color: #333;">
            效率<br>提升
          </div>
        </div>
 
        <div style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: center;">
          <div style="width: 80px; height: 40px; background: #f9f9f9; border-radius: 4px;"></div>
          <div style="width: 80px; height: 40px; background: #f9f9f9; border-radius: 4px;"></div>
          <div style="width: 80px; height: 40px; background: #f9f9f9; border-radius: 4px;"></div>
          <div style="width: 80px; height: 40px; background: #f9f9f9; border-radius: 4px;"></div>
        </div>
      </div>
    </div> -->
  </div>
</div>
</div>





			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				index:0
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			enter(e){
				this.index=e
			},
			leave(){
				this.index=0
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		/* background: #f7f7f7; */
	}

	.prduct-box {
		width: 1200px;
		/* padding-top: 60px; */
		padding-bottom: 100px;
		margin: 0 auto;
	}

	.center-body {
		margin: 0 auto;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
	.hxyx-box{
		height: 793px;
		background-image: url(../../assets/img/gywmbg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-top: 80px;
		text-align: center;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
	.active{
		color: #fff !important;
		background-color: #0070FD !important;
	}
</style>
